import { render } from "./Group.vue?vue&type=template&id=66922b68"
import script from "./Group.vue?vue&type=script&lang=js"
export * from "./Group.vue?vue&type=script&lang=js"
script.render = render

export default script